import type { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import Point from '@arcgis/core/geometry/Point';
import type { ArcgisMapView } from './arcgisView';
import { zoomMapViewToLocation } from './mapViewZoom';

export async function openMapItemPopup({
  mapView,
  longitude,
  latitude,
  title,
  zoom = 7,
  content,
}: {
  mapView: ArcgisMapView | null;
  longitude: number;
  latitude: number;
  title: string;
  zoom?: number;
  content: ReactNode;
}) {
  if (!mapView?.popup) return;

  await zoomMapViewToLocation({
    mapView,
    longitude,
    latitude,
    zoom,
  });

  const popupContent = document.createElement('div');
  popupContent.className = 'dark tw:bg-background tw:text-foreground';
  const root = createRoot(popupContent);
  root.render(content);

  await mapView.openPopup({
    title,
    location: new Point({ longitude, latitude }),
    content: popupContent,
  });

  const popup = mapView.popup;
  if (!popup) return;

  const handle = popup.watch('visible', (visible) => {
    if (!visible) {
      root.unmount();
      handle.remove();
    }
  });
}
